import Form from "../components/Form";
import {
  ClockIcon,
  EnvelopeIcon,
  MapPinIcon,
  PhoneIcon,
} from "@heroicons/react/24/outline";

const ContactPage = ({ id }) => {
  return (
    <section id={id} className="h-full flex flex-col gap-5 py-5">
      <div className="pt-5">
        <p className="text-black text-lg font-semibold xs:text-xl md:text-3xl lg:text-4xl lg:font-medium text-center py-3">
          Have a Question? We're Here to Help
        </p>
        <p className="text-gray-600 text-xs xs:text-base md:text-lg text-center px-2">
          Contact us through our form or direct channels, and let's make things
          happen together!
        </p>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2">
        <Form />
        <div className="flex items-center justify-center">
          <div className="grid grid-cols-2 grid-rows-2 gap-4 w-full md:w-3/4">
            <div className="border border-gray-200 grid grid-rows-[1fr_2fr] md:grid-rows-[2fr_2fr] hover:bg-midnight hover:text-gray-200 transition-colors duration-300 p-3 text-midnight xs:gap-5">
              <div className="flex items-center">
                <MapPinIcon className="w-15 lg:w-12 text-inherit" />
              </div>
              <div className="flex flex-col justify-end">
                <p className="text-inherit text-xl md:text-2xl lg:text-xl font-semibold text-left py-2">
                  Address
                </p>
                <p className="text-inherit text-md lg:text-sm text-left">
                  1319 F St NW, Ste 301, Washington, DC 20004
                </p>
              </div>
            </div>
            <div className="border border-gray-200 grid grid-rows-[1fr_2fr] md:grid-rows-[2fr_2fr] hover:bg-midnight hover:text-gray-200 transition-colors duration-300 p-3 text-midnight xs:gap-5">
              <div className="flex items-center">
                <PhoneIcon className="w-15 lg:w-12 text-inherit" />
              </div>
              <div className="flex flex-col justify-end">
                <p className="text-inherit text-xl md:text-2xl lg:text-xl font-semibold text-left py-2">
                  Phone
                </p>
                <p className="text-inherit text-md lg:text-sm text-left">
                  +1-202-607-2913
                </p>
              </div>
            </div>
            <div className="border border-gray-200 grid grid-rows-[1fr_2fr] md:grid-rows-[2fr_2fr] hover:bg-midnight hover:text-gray-200 transition-colors duration-300 p-3 text-midnight xs:gap-5">
              <div className="flex items-center">
                <EnvelopeIcon className="w-15 lg:w-12 text-inherit" />
              </div>
              <div className="flex flex-col justify-end">
                <p className="text-inherit text-xl md:text-2xl lg:text-xl font-semibold text-left py-2">
                  Email
                </p>
                <p className="text-inherit text-md lg:text-sm text-left">
                  info@colorizon.us
                </p>
              </div>
            </div>
            <div className="border border-gray-200 grid grid-rows-[1fr_2fr] md:grid-rows-[2fr_2fr] hover:bg-midnight hover:text-gray-200 transition-colors duration-300 p-3 text-midnight xs:gap-5">
              <div className="flex items-center">
                <ClockIcon className="w-15 lg:w-12 text-inherit" />
              </div>
              <div className="flex flex-col justify-end">
                <p className="text-inherit text-xl md:text-2xl lg:text-xl font-semibold text-left py-2">
                  Opening Hours
                </p>
                <p className="text-inherit text-md lg:text-sm text-left">
                  Mon – Fri, 9:00 AM – 5:00 PM
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactPage;
